// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Ecclesiasticus (Sirach)",
  bookSlug: "ecclesiasticus",
  chapter: 31,
  argument: "Of the desire of riches, and of moderation in eating and drinking.",
  verses: [
    { n: 1, text: "Watching for riches consumeth the flesh, and the thought thereof driveth away sleep." },
    { n: 2, text: "The thinking beforehand turneth away the understanding, and a grievous sickness maketh the soul sober." },
    { n: 3, text: "The rich man hath laboured in gathering riches together, and when he resteth he shall be filled with his goods." },
    { n: 4, text: "The poor man hath laboured in his low way of life, and in the end he is still poor." },
    { n: 5, text: "He that loveth gold, shall not be justified: and he that followeth after corruption, shall be filled with it." },
    { n: 6, text: "Many have been brought to fall for gold, and the beauty thereof hath been their ruin." },
    { n: 7, text: "Gold is a stumbling-block to them that sacrifice to it: woe to them that eagerly follow after it, and every fool shall perish by it." },
    { n: 8, text: "Blessed is the rich man that is found without blemish: and that hath not gone after gold, nor put his trust in money nor in treasures." },
    { n: 9, text: "Who is he, and we will praise him? for he hath done wonderful things in his life." },
    { n: 10, text: "Who hath been tried thereby, and made perfect, he shall have glory everlasting. He that could have transgressed, and hath not transgressed: and could do evil things, and hath not done them:" },
    { n: 11, text: "Therefore are his goods established in the Lord, and all the church of the saints shall declare his alms." },
    { n: 12, text: "Art thou set at a great table? be not the first to open thy mouth upon it." },
    { n: 13, text: "Say not: There are many things which are upon it." },
    { n: 14, text: "Remember that a wicked eye is evil." },
    { n: 15, text: "What is created more wicked than an eye? therefore shall it weep over all the face when it shall see." },
    { n: 16, text: "Stretch not out thy hand first, lest being disgraced with envy thou be put to confusion." },
    { n: 17, text: "Be not hasty in a feast." },
    { n: 18, text: "Judge of the disposition of thy neighbour by thyself." },
    { n: 19, text: "Use as a frugal man the things that are set before thee: lest if thou eatest much, thou be hated." },
    { n: 20, text: "Leave off first, for manners sake: and exceed not, lest thou offend." },
    { n: 21, text: "And if thou sittest among many, reach not thy hand out first of all: and be not the first to ask for drink." },
    { n: 22, text: "How sufficient is a little wine for a man well taught, and in sleeping thou shalt not be uneasy with it, and thou shalt feel no pain." },
    { n: 23, text: "Watching, and choler, and gripes, are with an intemperate man:" },
    { n: 24, text: "Sound and wholesome sleep with a moderate man: he shall sleep till morning, and his soul shall be delighted with him." },
    { n: 25, text: "And if thou hast been forced to eat much, arise, go out, and vomit: and it shall refresh thee, and thou shalt not bring sickness upon thy body." },
    { n: 26, text: "Hear me, my son, and despise me not: and in the end thou shalt find my words." },
    { n: 27, text: "In all thy works be quick, and no infirmity shall come to thee." },
    { n: 28, text: "The lips of many shall bless him that is liberal of his bread, and the testimony of his truth is faithful." },
    { n: 29, text: "Against him that is niggardly of his bread, the city will murmur, and the testimony of his niggardliness is true." },
    { n: 30, text: "Challenge not them that love wine: for wine hath destroyed very many." },
    { n: 31, text: "Fire trieth hard iron: so wine drunk to excess shall rebuke the hearts of the proud." },
    { n: 32, text: "Wine taken with sobriety is equal life to men: if thou drink it moderately, thou shalt be sober." },
    { n: 33, text: "What is his life, who is diminished with wine?" },
    { n: 34, text: "What taketh away life? death." },
    { n: 35, text: "Wine was created from the beginning to make men joyful, and not to make them drunk." },
    { n: 36, text: "Wine drunken with moderation is the joy of the soul, and the heart." },
    { n: 37, text: "Sober drinking is health to soul and body." },
    { n: 38, text: "Wine drunken with excess raiseth quarrels, and wrath, and many ruins." },
    { n: 39, text: "Wine drunken with excess is bitterness of the soul." },
    { n: 40, text: "The heat of drunkenness is the stumbling-block of the fool, lessening strength, and causing wounds." },
    { n: 41, text: "Rebuke not thy neighbour in a banquet of wine: and despise him not in his mirth." },
    { n: 42, text: "Speak not to him words of reproach: and press him not in demanding again." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Riches. Literally, \"honesty\" has this sense. (Haydock) — The study of virtue and of the Scriptures removes temptations of the flesh. (St. Jerome, ad Rust.)", attribution: "Worthington" }
    ] },
    { verse: 2, notes: [
      { text: "Hand. With too much anxiety. (Calmet) — Greek, \"the solicitude of watching will drive away slumber, and a grievous malady will moderate sleep,\" (Grabe; Haydock) or \"sleep will alleviate a severe illness,\" as experience evinces.", attribution: "Calmet" }
    ] },
    { verse: 4, notes: [
      { text: "Poor. All have not equal success, Proverbs x. 22, and Psalm cxxvi. 1.", attribution: "Drusius" }
    ] },
    { verse: 5, notes: [
      { text: "Justified. He is exposed to various temptations, 1 Timothy vi. 9.", attribution: "Haydock" }
    ] },
    { verse: 7, notes: [
      { text: "To it. Being a sort of idol, Colossians iii. 5. (Calmet) — Woe. Greek, \"and every,\" &c.", attribution: "Haydock" }
    ] },
    { verse: 8, notes: [
      { text: "Nor, &c. Greek, (9.) who, &c. \"Pride is the worm of riches.\" (St. Augustine) — \"In delights, chastity is endangered; and humility in the midst of riches.\" (St. Bernard, conv. Cler. xxx.) — Not to transgress, on such occasions, is the greatest miracle. (Calmet) — Man has free will, and those are happy, who, by God's grace, do not abuse it.", attribution: "Worthington" }
    ] },
    { verse: 11, notes: [
      { text: "In, &c. Alexandrian Greek, \"and wisdom (Grabe substitutes the Church) shall proclaim his alms.\" (Haydock) — God will bless his riches.", attribution: "Calmet" }
    ] },
    { verse: 12, notes: [
      { text: "Be, &c. Greek, \"do not open,\" (Haydock) shew not too much greediness.", attribution: "Haydock" }
    ] },
    { verse: 14, notes: [
      { text: "Wicked. Jealous or avaricious, as if the person feared lest he should have to prepare the like sumptuous entertainment, Proverbs xxiii. 1. Judas blamed the profusion of Magdalene, John xii. 5.", attribution: "Haydock" }
    ] },
    { verse: 15, notes: [
      { text: "Face. Or portion set before him, 1 Kings i. 5. (Calmet) — When. Greek, \"wheresoever it, (Haydock) or he (Calmet) shall look, stretch not forth thy hand, and strive not with him in the dish. Judge,\" &c. Let the envious person (Haydock) or the master be served first.", attribution: "Calmet" }
    ] },
    { verse: 19, notes: [
      { text: "Use. Greek, \"in all act considerately. Eat like a man,\" &c., (Haydock) not like a beast.", attribution: "Haydock" }
    ] },
    { verse: 20, notes: [
      { text: "First. Yet not too soon, lest the others should seem to be gluttons.", attribution: "Calmet" }
    ] },
    { verse: 21, notes: [
      { text: "Of all. Greek, \"of them. How,\" &c. (Haydock) — Politeness is grounded on virtue.", attribution: "Calmet" }
    ] },
    { verse: 22, notes: [
      { text: "Wine. Greek specifies nothing, and to eat much is unwholesome.", attribution: "Haydock" }
    ] },
    { verse: 23, notes: [
      { text: "Choler. Or the cholic. The intemperate, infrunito, (Calmet) Greek, \"insatiable,\" cannot sleep.", attribution: "Haydock" }
    ] },
    { verse: 25, notes: [
      { text: "Vomit. Some have omitted this term as indelicate; but the Scripture does not approve of intemperance, while it advises the preventing of a disorder. A man's stomach may sometimes be innocently overcharged. On such occasions, an emetic was prescribed. The ancients had not the same horror of it as moderns, Proverbs xxiii. 8. (Calmet) — Cicero, addressing C�sar, says, Cum te vomere post c�nam velli dixisses. (Pro. R. Dejot.) — And thou. Greek, \"hear,\" &c.", attribution: "Haydock" }
    ] },
    { verse: 27, notes: [
      { text: "Quick. Intemperance and idleness are the great sources of illness.", attribution: "Haydock" }
    ] },
    { verse: 28, notes: [
      { text: "Bread. And other provisions; while the miser is contemned, Proverbs xxii. 9. (Calmet) — Bread supports the body, and instruction the soul. If it be bad, it does the reverse.", attribution: "Worthington" }
    ] },
    { verse: 30, notes: [
      { text: "Challenge. Not to fight, or rather (Haydock) to drink, Isaias v. 22.", attribution: "Calmet" }
    ] },
    { verse: 31, notes: [
      { text: "Rebuke. Or disorder. Greek, \"prove,\" (Haydock) or \"lay open.\" (Calmet) — Consilium retegis Lydo.", attribution: "Horace, iii. ode 21." }
    ] },
    { verse: 32, notes: [
      { text: "Taken. Greek, \"is as good as life,\" &c. — Thou shalt. Greek, \"what,\" &c.", attribution: "Haydock" }
    ] },
    { verse: 33, notes: [
      { text: "With. Greek, \"destitute of wine, (35.) and this was created to,\" &c.", attribution: "Haydock" }
    ] },
    { verse: 35, notes: [
      { text: "And not. Greek, (36.) \"sufficient wine taken in season is the,\" &c.", attribution: "Haydock" }
    ] },
    { verse: 37, notes: [
      { text: "Sober. Greek, (39.) \"wine,\" &c. (Haydock) — Anacharsis said that \"the vine bore three clusters; the first of pleasure, the second of drunkenness, the third of discontent.\"", attribution: "Laertius i." }
    ] },
    { verse: 42, notes: [
      { text: "Reproach. Alexander [the Great] transfixed Clytus for so doing. (Curtius viii.) — Again. By the pernicious custom of drinking healths, which still prevails in some countries, (Calmet) and occasions people to get drunk. (Drusius) — Such abuses ought to be discouraged by every one.", attribution: "Haydock" }
    ] },
  ],
};

export default chapter;
